import React from "react";
import styled, { keyframes } from "styled-components";

const Loading = () => {
  return (
    <Wrapper role="status" aria-live="polite">
      <span className="ring" aria-hidden="true" />
      <span className="script">Načítáme…</span>
    </Wrapper>
  );
};

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

const Wrapper = styled.div`
  min-height: 45vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.25rem;
  padding: 4rem 1rem;

  .ring {
    width: 52px;
    height: 52px;
    border-radius: 50%;
    border: 3px solid var(--clr-divider);
    border-top-color: var(--clr-accent);
    animation: ${spin} 0.8s linear infinite;
  }

  .script {
    font-family: var(--ff-script);
    font-size: 1.5rem;
    color: var(--clr-accent-dark);
  }

  @media (prefers-reduced-motion: reduce) {
    .ring {
      animation: none;
    }
  }
`;

export default Loading;
